module.exports = __webpack_public_path__ + "static/media/step-3-id.c6304f03.jpg";